import { useState } from "react";
import { Grid, Button, CircularProgress } from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import axios from "../../customAxios.js";

const Fulfill = ({ user, selectedPrintLabels, setErrorOnRetrieveData }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleFulfillDeliveries = async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.post("deliveries/fulfill_deliveries/", {
        ids: selectedPrintLabels,
      });
      console.table(data);
      if (setErrorOnRetrieveData) setErrorOnRetrieveData();
      window.location.reload(true);
    } catch (error) {
      console.error(`[EXCEPTION] ${error}`);
      if (setErrorOnRetrieveData)
        setErrorOnRetrieveData("Ocurrió un error al procesar los envios");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid item md={2} xs={6}>
      <Button
        variant="outlined"
        onClick={handleFulfillDeliveries}
        disabled={isLoading}
      >
        {isLoading ? (
          <CircularProgress className="loading-btn" />
        ) : (
          <>
            <InventoryIcon fontSize="small" /> Preparar envíos
          </>
        )}
      </Button>
    </Grid>
  );
};

export default Fulfill;
